'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Misc = require('@/helpers/Misc');

var Misc = _interopRequireWildcard(_Misc);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _Logger = require('@/libs/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _BouncerProvider = require('@/libs/BouncerProvider');

var _BouncerProvider2 = _interopRequireDefault(_BouncerProvider);

var _CommonLayout = require('./CommonLayout');

var _CommonLayout2 = _interopRequireDefault(_CommonLayout);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = _Logger2.default.namespace('Welcome.vue');

exports.default = {
    components: {
        StartupLayout: _CommonLayout2.default
    },
    data: function data() {
        return {
            network: null,
            channel: '',
            nick: '',
            password: '',
            showChannel: true,
            showPass: true,
            toggablePass: true,
            showNick: true,
            show_password_box: false,
            recaptchaSiteId: '',
            recaptchaResponseCache: '',
            connectWithoutChannel: false,
            showPlainText: false
        };
    },
    computed: {
        greetingText: function greetingText() {
            var greeting = _state2.default.settings.startupOptions.greetingText;
            return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
        },
        footerText: function footerText() {
            var footer = _state2.default.settings.startupOptions.footerText;
            return typeof footer === 'string' ? footer : '';
        },
        buttonText: function buttonText() {
            var greeting = _state2.default.settings.startupOptions.buttonText;
            return typeof greeting === 'string' ? greeting : this.$t('start_button');
        },
        readyToStart: function readyToStart() {
            var ready = !!this.nick;

            if (!this.connectWithoutChannel && !this.channel) {
                ready = false;
            }

            if (!this.toggablePass && !this.password) {
                ready = false;
            }

            var nickPatternStr = this.$state.setting('startupOptions.nick_format');
            var nickPattern = '';
            if (!nickPatternStr) {
                nickPattern = /^[a-z_\\[\]{}^`|][a-z0-9_\-\\[\]{}^`|]*$/i;
            } else {
                var pattern = '';
                var flags = '';
                if (nickPatternStr[0] === '/') {
                    var pos = nickPatternStr.lastIndexOf('/');
                    pattern = nickPatternStr.substring(1, pos);
                    flags = nickPatternStr.substr(pos + 1);
                } else {
                    pattern = _lodash2.default.escapeRegExp(nickPatternStr);
                    flags = 'i';
                }

                try {
                    nickPattern = new RegExp(pattern, flags);
                } catch (error) {
                    log.error('Nick format error: ' + error.message);
                    return false;
                }
            }

            if (!this.nick.match(nickPattern)) {
                ready = false;
            }

            return ready;
        }
    },
    created: function created() {
        var options = _state2.default.settings.startupOptions;

        var previousNet = null;
        if (options.server.trim()) {
            previousNet = _state2.default.getNetworkFromAddress(options.server.trim());
        }

        if (Misc.queryStringVal('nick')) {
            this.nick = Misc.queryStringVal('nick');
        } else if (previousNet && previousNet.connection.nick) {
            this.nick = previousNet.connection.nick;
        } else {
            this.nick = options.nick;
        }

        this.nick = this.processNickRandomNumber(this.nick || '');
        this.password = options.password || '';
        this.channel = decodeURIComponent(window.location.hash) || options.channel || '';
        this.showChannel = typeof options.showChannel === 'boolean' ? options.showChannel : true;
        this.showNick = typeof options.showNick === 'boolean' ? options.showNick : true;
        this.showPass = typeof options.showPassword === 'boolean' ? options.showPassword : true;
        this.toggablePass = typeof options.toggablePassword === 'boolean' ? options.toggablePassword : true;

        this.connectWithoutChannel = !!options.allowNoChannel;

        if (options.bouncer) {
            this.toggablePass = false;
            this.showPass = true;
            this.showChannel = false;
            this.connectWithoutChannel = true;

            var bouncer = new _BouncerProvider2.default(this.$state);
            bouncer.enable(options.server, options.port, options.tls, options.direct, options.path);
        }

        if (options.autoConnect && this.nick && (this.channel || this.connectWithoutChannel)) {
            this.startUp();
        }

        this.recaptchaSiteId = options.recaptchaSiteId || '';
    },
    mounted: function mounted() {
        if (this.recaptchaSiteId) {
            var scr = document.createElement('script');
            scr.src = 'https://www.google.com/recaptcha/api.js';
            this.$el.appendChild(scr);
        }
    },

    methods: {
        captchaSuccess: function captchaSuccess() {
            if (!this.recaptchaSiteId) {
                return true;
            }

            return !!this.captchaResponse();
        },
        captchaResponse: function captchaResponse() {
            if (this.recaptchaResponseCache) {
                return this.recaptchaResponseCache;
            }

            var gEl = this.$el.querySelector('#g-recaptcha-response');
            this.recaptchaResponseCache = gEl ? gEl.value : '';

            return this.recaptchaResponseCache;
        },
        readableStateError: function readableStateError(err) {
            return Misc.networkErrorMessage(err);
        },

        formSubmit: function formSubmit() {
            if (this.readyToStart) {
                this.startUp();
            }
        },
        startUp: function startUp() {
            var _this = this;

            var options = (0, _assign2.default)({}, _state2.default.settings.startupOptions);

            options.server = options.server || 'default';
            options.port = options.port || 6667;

            if (!this.captchaSuccess()) {
                return;
            }

            var netAddress = _lodash2.default.trim(options.server);

            var net = this.network || _state2.default.getNetworkFromAddress(netAddress);

            var password = this.password;
            if (options.bouncer) {
                password = this.nick + ':' + this.password;
            }

            net = net || _state2.default.addNetwork('Network', this.nick, {
                server: netAddress,
                port: options.port,
                tls: options.tls,
                password: password,
                encoding: _lodash2.default.trim(options.encoding),
                direct: !!options.direct,
                path: options.direct_path || '',
                gecos: options.gecos
            });

            net.connection.nick = this.nick;
            net.password = password;

            if (_lodash2.default.trim(options.encoding || '')) {
                net.connection.encoding = _lodash2.default.trim(options.encoding);
            }

            if (!this.network && options.recaptchaSiteId) {
                net.captchaResponse = this.captchaResponse();
            }
            this.network = net;

            var hasSwitchedActiveBuffer = false;
            var bufferObjs = Misc.extractBuffers(this.channel);
            bufferObjs.forEach(function (bufferObj) {
                var newBuffer = _state2.default.addBuffer(net.id, bufferObj.name);
                newBuffer.enabled = true;

                if (newBuffer && !hasSwitchedActiveBuffer) {
                    _state2.default.setActiveBuffer(net.id, newBuffer.name);
                    hasSwitchedActiveBuffer = true;
                }

                if (bufferObj.key) {
                    newBuffer.key = bufferObj.key;
                }
            });

            if (!hasSwitchedActiveBuffer) {
                _state2.default.setActiveBuffer(net.id, net.serverBuffer().name);
            }

            net.ircClient.connect();
            var onRegistered = function onRegistered() {
                if (_this.$refs.layout) {
                    _this.$refs.layout.close();
                }
                net.ircClient.off('registered', onRegistered);
                net.ircClient.off('close', onClosed);
            };
            var onClosed = function onClosed() {
                net.ircClient.off('registered', onRegistered);
                net.ircClient.off('close', onClosed);
            };
            net.ircClient.once('registered', onRegistered);
            net.ircClient.once('close', onClosed);
        },
        processNickRandomNumber: function processNickRandomNumber(nick) {
            var tmp = (nick || '').replace(/\?/g, function () {
                return Math.floor(Math.random() * 100).toString();
            });
            return _lodash2.default.trim(tmp);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["Welcome"]
window._kiwi_exports.components.startups.Welcome = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/startups/Welcome.vue
// module id = nt8X
// module chunks = 1